import mitt from 'mitt';

type Events = {
  'shipment-updated': {
    userId: string;
    userName: string;
    shipmentNumber: string;
    shipmentId: string;
    description?: string;
    changes: Array<{
      field: string;
      oldValue: any;
      newValue: any;
    }>;
  };
  'show-alert': {
    type: 'success' | 'error';
    message: string;
  };
};

export const eventBus = mitt<Events>();
